<template>
  <CRow>
    <CCol col="12" xl="12">
      <Spinner v-if="$store.state.loadSpinner" />

      <CCard v-else>
        <CCardHeader>
          <span>الادارة </span>

          <CButton
            class="float-right"
            color="info"
            @click="
              $router.push({
                name: `Create Admin`,
              })
            "
          >
            <CIcon name="cil-plus"></CIcon>
            <span> اضافة اداري </span>
          </CButton>
        </CCardHeader>
        <CCardBody>
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover mb-5">
              <thead>
                <tr class="table-primary">
                  <th scope="col">#</th>
                  <th scope="col">الاسم</th>
                  <th scope="col">اسم المستخدم</th>
                  <th scope="col">الموبايل</th>
                  <th scope="col">الحالة</th>
                  <th scope="col">الاجراءات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <th scope="row">{{ item.id }}</th>
                  <td>{{ item.name }}</td>
                  <td>{{ item.username }}</td>
                  <td>{{ item.mobile }}</td>
                  <td>
                    <b :class="`text-${getBadge(item.is_active)}`">
                      {{ item.is_active ? "نشط" : "متوقف" }}
                    </b>
                  </td>
                  <td>
                    <CButton
                      class="mx-1"
                      color="warning"
                      @click="openModal(item)"
                    >
                      <CIcon name="cil-pencil"></CIcon>
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <CPagination :active-page.sync="currentPage" :pages="totalPages" />
        </CCardBody>
      </CCard>
    </CCol>
    <edit :form="modalForm" @updateDone="updateDone"></edit>
  </CRow>
</template>

<script>
import Edit from "./Edit";
export default {
  name: "Admins",
  components: {
    Edit,
  },
  data() {
    return {
      items: [],
      activePage: 1,
      currentPage: 1,
      totalPages: 0,
      allPages: 10,
      modalForm: null,
    };
  },
  watch: {
    currentPage: {
      handler: function (val, oldVal) {
        this.fetchData(val);
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(page = 1) {
      this.toggleLoadSpinner();

      this.$http
        .get(`/admins/list-all?per_page=15&page=${page}`)
        .then((res) => {
          // handle success
          this.items = res.data.data;
          this.totalPages = res.data.last_page;
          this.toggleLoadSpinner();
        })
        .catch((error) => {
          //
          this.toggleLoadSpinner();
        });
    },

    toggleLoadSpinner() {
      this.$store.commit("toggleLoadSpinner");
    },

    stopAdmin(itemId) {
      console.log(itemId);
    },

    getBadge(status) {
      switch (status) {
        case 1:
          return "success";
        case 0:
          return "danger";
        default:
          "primary";
      }
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    openModal(item) {
      this.modalForm = Object.assign({}, item);
      this.$store.commit("set", ["showModal", true]);
    },
    updateDone() {
      this.fetchData();
    },
  },
};
</script>